import { useState } from "react";

export function useOnboardingFlow(initialStep = 1): {
  currentStep: number;
  goToNextStep: () => void;
  goToPreviousStep: () => void;
  goToStep: (step: number) => void;
  isFirstStep: boolean;
  isLastStep: boolean;
  setStep: (step: number) => void;
  totalSteps: number;
} {
  const [currentStep, setCurrentStep] = useState(initialStep);
  const totalSteps = 4; // 1: Personal Info, 2: Email Verification, 3: Thank You, 4: Password Creation

  const goToNextStep = () => {
    setCurrentStep((prev) => Math.min(prev + 1, totalSteps));
  };

  const goToPreviousStep = () => {
    setCurrentStep((prev) => Math.max(prev - 1, 1));
  };

  const goToStep = (step: number) => {
    if (step >= 1 && step <= totalSteps) {
      setCurrentStep(step);
    }
  };

  const setStep = (step: number) => {
    setCurrentStep(step);
  };

  return {
    currentStep,
    goToNextStep,
    goToPreviousStep,
    goToStep,
    isFirstStep: currentStep === 1,
    isLastStep: currentStep === totalSteps,
    setStep,
    totalSteps,
  };
}
